import { render, staticRenderFns } from "./StepFrontPage.vue?vue&type=template&id=6c8f3db2&"
import script from "./StepFrontPage.vue?vue&type=script&lang=js&"
export * from "./StepFrontPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports